// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./bell-black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./bell-white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Jh1Z6V{top:20px}html[dir='ltr'] .Jh1Z6V{left:20px}html[dir='rtl'] .Jh1Z6V{right:20px}.Jh1Z6V.K2yWq7.BKXDsT{flex-direction:row-reverse;top:6px}html[dir='ltr'] .Jh1Z6V.K2yWq7.BKXDsT{left:10px}html[dir='rtl'] .Jh1Z6V.K2yWq7.BKXDsT{right:10px}.Jh1Z6V.K2yWq7.BKXDsT .ZhBQuu{width:19px;height:16px}.Jh1Z6V.K2yWq7.Porvlq{top:5px}html[dir='ltr'] .Jh1Z6V.K2yWq7.Porvlq{left:5px}html[dir='rtl'] .Jh1Z6V.K2yWq7.Porvlq{right:5px}.Jh1Z6V:hover .ZhBQuu{background:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;background-size:contain}.ZhBQuu{width:22px;height:15px;background:url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center;background-size:contain}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"live-label": `Jh1Z6V`,
	"liveLabel": `Jh1Z6V`,
	"mobile": `K2yWq7`,
	"scheduled": `BKXDsT`,
	"reminder-icon": `ZhBQuu`,
	"reminderIcon": `ZhBQuu`,
	"streaming": `Porvlq`
};
export default ___CSS_LOADER_EXPORT___;
